import { Decorative } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { HeroSection } from "@faire/retailer/views/careers/__internal__/components/HeroSection";
import { ViewOpeningsButton } from "@faire/retailer/views/careers/ViewOpeningsButton";

const IMAGES = [
  "https://cdn.faire.com/fastly/dfbccf2f0862fdd386cabdcb3973171f2b9df34f227fb5a40c493ee413b9a98b.png",
  "https://cdn.faire.com/fastly/5f9bfc9088849100279d2997bc7455d5aec798ce0ce344d4ff7dcdc6323da027.png",
  "https://cdn.faire.com/fastly/ef73f15846d4761110e6fbb220738924182ebc334919e50665ac3571c90f935f.png",
  "https://cdn.faire.com/fastly/bb9f7102e976e8f09824e187f8ba42d35a27ed4a2bf887d48598076fdc4e0bcc.png",
  "https://cdn.faire.com/fastly/3bbfdf1cafad740c1d05cfec2bc1e174713969baaf5ed14fd7fff9bdb115c32d.png",
  "https://cdn.faire.com/fastly/070dde03b511a074a7fc1a62d8c6b76d8552e490a9bd3b92f3a1aecd88b2c0fa.png",
];

interface IProps {
  openingsCount: number;
  isLoading: boolean;
}

export const LandingPageHeroSection: React.FC<IProps> = ({
  openingsCount,
  isLoading,
}: IProps) => {
  const { strictLocalize } = useStrictLocalization();
  const { isDesktopAndAbove } = useViewport();
  const headerText = strictLocalize({
    defaultMessage:
      "Help us empower brands and retailers to strengthen the unique character of local communities",
    description: {
      text: "Title to talk about Faire's mission, to help our brands and retailers and to build the local communities",
    },
  });
  const eyebrowText = strictLocalize({
    defaultMessage: "Life At Faire",
    description: {
      text: "Title to the hero section of careers landing page",
    },
  });

  return (
    <HeroSection
      eyebrowText={eyebrowText}
      heroImages={IMAGES}
      backgroundColor={Decorative.tint.neutral}
    >
      <HeaderMinWidthTypography
        variant={{
          mobileAndAbove: "displaySSerifRegular",
          desktopAndAbove: "displayMSerifRegular",
        }}
      >
        {headerText}
      </HeaderMinWidthTypography>
      <Spacer height={isDesktopAndAbove ? "4x" : "3x"} />
      <HiddenLoadingTypography
        $isLoading={isLoading}
        variant={{
          mobileAndAbove: "paragraphSansRegular",
          desktopAndAbove: "subheadingSansMedium",
        }}
      >
        <StrictLocalMsg
          defaultMessage="{openingsCountNumber} openings to join the team"
          description={{
            text: "Line to show how many openings are available",
          }}
          values={{ openingsCountNumber: openingsCount }}
        />
      </HiddenLoadingTypography>
      <Spacer size={isDesktopAndAbove ? "3x" : "2x"} />
      <ViewOpeningsButton />
    </HeroSection>
  );
};

const HeaderMinWidthTypography = styled(Typography)`
  ${responsiveMediaQueries.xLargeAndAbove} {
    min-width: 424px;
  }
`;

const HiddenLoadingTypography = styled(Typography)<{
  $isLoading: boolean;
}>`
  visibility: ${(props) => (props.$isLoading ? "hidden" : "visible")};
`;
